"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePriceLogic = void 0;
var _checkoutUtils = require("@ori/checkout-utils");
var _react = require("react");
var _context = require("../../context");
const usePriceLogic = () => {
  const {
    basicCataloguePrice,
    cataloguePrice,
    isAvailable,
    priceName,
    unitPrice
  } = (0, _context.useItemContext)();
  const priceLogic = (0, _react.useMemo)(() => {
    const isBrandPartner = priceName === 'cataloguePrice';
    const cataloguePriceNumber = (0, _checkoutUtils.parseNumberFromString)(cataloguePrice);
    const basicCataloguePriceNumber = (0, _checkoutUtils.parseNumberFromString)(basicCataloguePrice);
    const unitPriceNumber = (0, _checkoutUtils.parseNumberFromString)(unitPrice);
    if (!isAvailable) {
      return {
        regularPrice: '',
        showCataloguePrice: false,
        showBasicCataloguePrice: false
      };
    }

    // there is different logic for brand partners and for other customers
    if (isBrandPartner) {
      const regularPrice = cataloguePrice;
      const showCataloguePrice = cataloguePriceNumber > 0;
      const showBasicCataloguePrice = (0, _checkoutUtils.isNullableStringAGreaterThanB)(basicCataloguePrice, cataloguePrice);
      return {
        regularPrice,
        showCataloguePrice,
        showBasicCataloguePrice
      };
    }

    // 1. When BasicCataloguePrice <> CataloguePrice AND CataloguePrice = UnitPrice --> Display BasicCataloguePrice as regular price
    // 2. When BasicCataloguePrice <> CataloguePrice AND CataloguePrice <> UnitPrice --> Display CataloguePrice as regular price
    // 3. When BasicCataloguePrice = CataloguePrice --> Do not display regular price
    const showBasicCataloguePrice = false;
    const regularPrice = cataloguePriceNumber === unitPriceNumber ? basicCataloguePrice : cataloguePrice;
    const showCataloguePrice = (0, _checkoutUtils.parseNumberFromString)(regularPrice) > 0 && basicCataloguePriceNumber !== cataloguePriceNumber;
    return {
      regularPrice,
      showCataloguePrice,
      showBasicCataloguePrice
    };
  }, [basicCataloguePrice, cataloguePrice, isAvailable, priceName, unitPrice]);
  return {
    priceLogic
  };
};
exports.usePriceLogic = usePriceLogic;
//# sourceMappingURL=usePriceLogic.js.map